import axios, { AxiosError } from "axios";
import { TypeUser } from "../utility/types/user";
import { alert } from "../@core/components/alert";

const token =
  localStorage.getItem("@revalida.token") != null
    ? JSON.parse(localStorage.getItem("@revalida.token") ?? "")
    : "";

export const api = axios.create({
  baseURL: import.meta.env.VITE_APP_URL_API,
  timeout: 1200000, // 20minutos
  timeoutErrorMessage: "timeout",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  if (config.url && /^\/?meet\/[^/]+\/enter/.test(config.url)) {
    delete config.headers["Authorization"];
  } else {
    const token = localStorage.getItem("@revalida.token");
    if (
      token &&
      token !== "null" &&
      token !== "undefined" &&
      token !== '""' &&
      token !== ""
    ) {
      config.headers["Authorization"] = `Bearer ${JSON.parse(token)}`;
    } else {
      delete config.headers["Authorization"];
    }
  }
  return config;
});

type FailedRequestData = {
  onSuccess: (token: string) => void;
  onFailure: (err: AxiosError) => void;
};
let isRefreshing = false;
let failedRequest: FailedRequestData[] = [];
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    const user: TypeUser = JSON.parse(
      localStorage.getItem("@revalida.user") as any
    );
    if (error.response?.status === 401) {
      if (error.response.data === "token expirado") {
        const originalConfig: any = error.config;
        if (!isRefreshing) {
          isRefreshing = true;

          api
            .get("refresh")
            .then((response) => {
              // const { token } = response.data;
              localStorage.setItem("@revalida.token", JSON.stringify(token));
              api.defaults.headers["Authorization"] = `Bearer ${token}`;

              failedRequest.forEach((request) => {
                request.onSuccess(token);
              });
              failedRequest = [];
            })
            .catch((err) => {
              failedRequest.forEach((request) => request.onFailure(err));
              failedRequest = [];
            })
            .finally(() => {
              isRefreshing = false;
            });
        }
        return new Promise((resolve, reject) => {
          failedRequest.push({
            onSuccess: (access_token: string) => {
              originalConfig.headers[
                "Authorization"
              ] = `Bearer ${access_token}`;
              resolve(api(originalConfig));
            },
            onFailure: (err: AxiosError) => {
              reject(err);
            },
          });
        });
      } else if (
        error.response.data === "Tempo de atualização de token expirado" ||
        error.response.data == "token na blacklist"
      ) {
        localStorage.removeItem("@revalida.user");
        localStorage.removeItem("@revalida.token");
        alert("Acesso expirado, redirecionado para login", "error");
        location.href = "/login";
      }
      // else if (error.response.data == "Acesso não autorizado") {
      //   localStorage.removeItem("@revalida.user");
      //   localStorage.removeItem("@revalida.token");
      //   alertRedirect(
      //     "Identificamos acesso simultâneo nessa conta. Você será redirecionado para o login.",
      //     "error",
      //     "/login"
      //   );
      // }
    }
    // if (error.response?.status === 404) {
    //   if (error.response.data == "usuario não encontrado") {
    //     localStorage.removeItem("@revalida.user");
    //     localStorage.removeItem("@revalida.token");
    //     alert("Usuário não encontrado, redirecionado para login", "error");
    //     location.href = "/login";
    //   }
    // }

    // if (error.response?.status === 0 || error.code == "ERR_NETWORK") {
    //   alert(
    //     "Servidor da api fora do ar, Entrar em contato com o administrador. Tente novamente mais tarde",
    //     "error"
    //   );
    //   error["data"] =
    //     "Servidor da api fora do ar, Entrar em contato com o administrador. Tente novamente mais tarde";
    //   return Promise.reject(error);
    // }
    return Promise.reject(error);
  }
);
export function getRequest(URL, config?) {
  return api.get(`${URL}`, config).then((response) => response.data);
}

export function postRequest(URL, payload) {
  return api.post(`${URL}`, payload).then((response) => response.data);
}
export function postRequestMultiPart(URL, payload) {
  return api
    .post(`${URL}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
}
export function patchRequest(URL, payload) {
  return api.patch(`${URL}`, payload).then((response) => response.data);
}
export function putRequest(URL, payload?) {
  return api.put(`${URL}`, payload).then((response) => response.data);
}
export function deleteRequest(URL, config?) {
  return api.delete(`${URL}`, config).then((response) => response.data);
}
